import { render, staticRenderFns } from "./UserEmail.vue?vue&type=template&id=3918007e&scoped=true"
import script from "./UserEmail.vue?vue&type=script&lang=ts"
export * from "./UserEmail.vue?vue&type=script&lang=ts"
import style0 from "./UserEmail.vue?vue&type=style&index=0&id=3918007e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3918007e",
  null
  
)

export default component.exports